import { useState, useEffect, useRef } from 'react';
import {
    Box, TextField, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography,
    InputAdornment, Grid, Container, styled, CircularProgress, Autocomplete, TablePagination, IconButton, Tooltip,
    Divider, Chip, DialogContent, Dialog, DialogTitle, Breadcrumbs, Link
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import SearchIcon from '@mui/icons-material/Search';
import EventIcon from '@mui/icons-material/Event';
import PrintIcon from '@mui/icons-material/Print';
import dayjs from 'dayjs';
import { fetchResident } from "../../Components/Masters/Billing/Api/Api";
import { getRoomMasterdropdata } from '../../Api/PropertyMst/Api';
import { toast, ToastContainer } from 'react-toastify';
import axios from 'axios';
import logo from '../../assets/Images/Clanbridge-logo.png2.png';
import 'dayjs/locale/en-gb';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import axiosInstance from '../../lib/axios';
import TableComponentPending from '../../atoms/TableComponent/PendingAdvice';
import { Send as SendIcon } from '@mui/icons-material';
import HomeIcon from '@mui/icons-material/Home';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import moment from 'moment';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ExcelJS from 'exceljs';

// Styled components
const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
    marginTop: theme.spacing(1),
    maxHeight: '400px',
}));

const StyledTableHead = styled(TableHead)(({ theme }) => ({
    '& .MuiTableCell-head': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
    },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    color: theme.palette.common.white,
    fontWeight: 'bold',
}));

const StyledButton = styled(Button)(({ theme }) => ({
    padding: '7px 24px',
    borderRadius: '8px',
    textTransform: 'none',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    '&:hover': {
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    },
}));

const FilterSection = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    borderRadius: '12px',
    boxShadow: '0 2px 15px rgba(0,0,0,0.05)',
    marginBottom: theme.spacing(1),
}));

const pendingColumns = [
    { id: 'BookNo', label: 'Booking No', align: 'left', width: '100px' },
    { id: 'PropName', label: 'Property', align: 'left', width: '130px' },
    { id: 'MobileNo', label: 'MobileNo', align: 'left', width: '120px' },
    { id: 'RoombedName', label: 'Unit', align: 'left', width: '100px' },
    { id: 'ResidentName', label: 'Resident', align: 'left', width: '130px' },
    { id: 'Amount', label: 'Adv Amt', align: 'left', width: '100px' },
    { id: 'BalAmount', label: 'Bal Amt', align: 'center', width: '70px' },
    { id: 'DueDays', label: 'Due Days', align: 'center', width: '80px', },
    { id: 'DueDt', label: 'Due Date', align: 'center', width: '120px' },
    { id: 'Remark', label: 'Remark', align: 'left', width: '100px' },
];

const ResidentWiseDtl = () => {
    // const currentYear = dayjs().year();
    // const previousYear = currentYear - 1;
    // const [fromDate, setFromDate] = useState(dayjs(`${previousYear}-04-01`));
    // const [toDate, setToDate] = useState(dayjs(`${currentYear}-04-01`).subtract(1, 'day'));

    const today = dayjs();

    let startYear, endYear;

    if (today.month() >= 3) {
        startYear = today.year();
        endYear = today.year() + 1;
    } else {
        startYear = today.year() - 1;
        endYear = today.year();
    }

    const [fromDate, setFromDate] = useState(dayjs(`${startYear}-04-01`));
    const [toDate, setToDate] = useState(dayjs(`${endYear}-03-31`));
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [selectedProperty, setSelectedProperty] = useState({ Id: '1', Name: 'All' });
    const [selectedResident, setSelectedResident] = useState({ Id: '1', Name: 'All' });
    const [loading, setLoading] = useState(false);
    const [tableLoading, setTableLoading] = useState(false);
    const [property, setProperty] = useState([]);
    const [residents, setResidents] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    const [statusFilter, setStatusFilter] = useState('All');
    const [filteredPendingData, setFilteredPendingData] = useState([]);
    const [selectedPendingRows, setSelectedPendingRows] = useState([]);
    const [isPendingLoading, setIsPendingLoading] = useState(false);
    const [pendingData, setPendingData] = useState([]);
    const [filteredRows, setFilteredRows] = useState([]);
    const [pendingSearchTerms, setPendingSearchTerms] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [paymentStatus, setPaymentStatus] = useState('Unpaid');
    const navigate = useNavigate()
    const [openModal, setOpenModal] = useState(false);
    const [viewMode, setViewMode] = useState('default');
    const token = `eyJhbGciOiJIUzI1NiJ9.eyJWYWxpZElzc3VlciI6IlByYXN5c3QiLCJWYWxpZEF1ZGllbmNlIjoiUHJhc3lzdCJ9.gMMGQ74cWLoymeDv0D4c3UQKTEJSCzdkXoxlW4qF5QU`;

    const handlePendingSearchChange = (columnId, value) => {
        setPendingSearchTerms(prev => ({ ...prev, [columnId]: value }));
    };

    const handleOpenReceipt = async () => {
        setTableLoading(true);
        setStatusFilter('Receipt');

        try {
            const response = await axiosInstance.post('BookingReports/GetBookingReportsDetail', {
                BookDtFrom: fromDate.format('YYYY-MM-DD'),
                BookUpToDt: toDate.format('YYYY-MM-DD'),
                PropId: selectedProperty?.Id || 0,
                Flag: 'LedgerTrnRctVchr',
            });

            if (response.data.Status === 0 && Array.isArray(response.data.Data)) {
                const transformedData = response.data.Data.map(item => ({
                    PytAdvNo: item.PytAdvNo,
                    ResidentName: item.FirstName,
                    PytAdvDt: item.PytAdvDt,
                    DueDt: item.PytAdvDt,
                    Amount: item.PyAmount || 0,
                    RcdAmt: item.PyAmount - item.PyBalAmount || 0,
                    BalAmount: item.PyBalAmount || 0,
                    status: getStatus({
                        BalAmount: item.PyBalAmount,
                        DueDt: item.PytAdvDt,
                    })
                }));

                setData(transformedData);
                setFilteredData(transformedData);
                setPage(0);
            } else {
                toast.info("No receipt data found.");
                setData([]);
                setFilteredData([]);
            }
        } catch (error) {
            toast.error("Error fetching receipt data.");
            setData([]);
            setFilteredData([]);
        } finally {
            setTableLoading(false);
        }
    };

    const fetchPropertyData = async () => {
        try {
            const userId = sessionStorage.getItem('UserId');
            const response = await getRoomMasterdropdata({
                Flag: '',
                UserId: userId,
            });

            if (response.data.Status === 0) {
                const propertyList = response.data.Data;
                const allOption = { Id: '1', Name: 'All' };
                const updatedProperties = [allOption, ...propertyList];
                setProperty(updatedProperties);
                setSelectedProperty(allOption); // Set "All" as default
            } else {
                toast.error(response.data.Message || 'Error fetching property data');
            }
        } catch (error) {
            toast.error('Failed to fetch property data');
        }
    };

    const fetchResidentData = async () => {
        try {
            const response = await fetchResident({
                start: 1,
                PageSize: 1,
                SearchText: "drp",
            });

            if (response?.data?.Data) {
                // setResidents(response.data.Data);
                const residentList = response.data.Data;
                const allOption = { Id: '1', Name: 'All' };
                const updatedResidents = [allOption, ...residentList];
                setResidents(updatedResidents);
                setSelectedResident(allOption);
            } else {
                toast.error("No residents data found");
            }
        } catch (error) {
            toast.error("Failed to load residents data");
        }
    };

    const fetchOutstandingReports = async () => {
        try {
            setTableLoading(true);
            const payload = {
                PytAdvFrmDt: fromDate.format('YYYY-MM-DD'),
                PytAdvToDt: toDate.format('YYYY-MM-DD'),
                PropId: selectedProperty?.Id?.toString(),
                ResidentId: selectedResident?.Id?.toString(),
                Flag: 'AccSum',
            };

            // Only include ResidentId if it's not "All"
            if (selectedResident?.Id !== '1') {
                payload.ResidentId = selectedResident?.Id?.toString();
            }

            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}OutStandingReports/GetOutStandingReports`,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data.Status === 0) {
                const processedData = response.data.Data.map(item => ({
                    ...item,
                    status: getStatus(item)
                }));
                setData(processedData);
                setFilteredData(processedData);
            } else {
                toast.error(response.data.Message || "No data found");
                setData([]);
                setFilteredData([]);
            }
        } catch (error) {
            setData([]);
            setFilteredData([]);
        } finally {
            setTableLoading(false);
        }
    };

    const fetchOverdueReports = async () => {
        try {
            setTableLoading(true);
            const payload = {
                PropId: selectedProperty?.Id?.toString(),
                BookDtFrom: fromDate.format('YYYY-MM-DD'),
                BookUpToDt: toDate.format('YYYY-MM-DD'),
                Flag: "",
                Cwhere: "",
                Strwhere: ""
            };

            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}TrnBooking/ResidentOsRpt`,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data.Status === 0) {
                const processedData = response.data.Data.map(item => ({
                    ...item,
                    status: getStatus(item)
                }));
                setData(processedData);
                setFilteredData(processedData);
                setStatusFilter('Overdue');
            } else {
                toast.error(response.data.Message || "No overdue data found");
                setData([]);
                setFilteredData([]);
            }
        } catch (error) {
            toast.error("Failed to load overdue reports");
            setData([]);
            setFilteredData([]);
        } finally {
            setTableLoading(false);
        }
    };

    const getStatus = (item) => {
        if (item.BalAmount === 0) {
            return 'Paid';
        } else if (dayjs(item.DueDt).isBefore(dayjs(), 'day')) {
            return 'Overdue';
        } else {
            return 'Pending';
        }
    };

    const filterByStatus = (status) => {
        setStatusFilter(status);

        if (status === 'Overdue') {
            fetchOverdueReports();
        } else if (status === 'All') {
            setFilteredData(data);
        } else {
            setFilteredData(data.filter(item => getStatus(item) === status));
        }
        setPage(0);
    };

    useEffect(() => {
        fetchPropertyData();
        fetchResidentData();
    }, []);

    const handlePropertyChange = (event, newValue) => {
        setSelectedProperty(newValue);
    };

    const handleResidentChange = (event, newValue) => {
        setSelectedResident(newValue);
        fetchOutstandingReports();
    };

    const [summary, setSummary] = useState({
        currentPage: { totalAmount: 0, paidAmount: 0, outstanding: 0 },
        overall: { totalAmount: 0, paidAmount: 0, outstanding: 0 }
    });

    const handleReset = () => {
        setSelectedProperty(null);
        setSelectedResident(null);
        setFromDate(dayjs().subtract(1, 'month'));
        setToDate(dayjs());
        setData([]);
        setFilteredData([]);
        setStatusFilter('All');
        setPage(0);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const paginatedData = filteredData?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    const tableRef = useRef();

    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        const currentDate = new Date().toLocaleString();
        const logoHtml = logo ? `<img src="${logo}" style="height: 35px; margin-bottom: 10px;" alt="logo" />` : '';
        const currentPageSummary = getCurrentPageSummary(filteredData, page, rowsPerPage);
        const overallSummary = getOverallSummary(filteredData);

        const tableHtml = `
            <html>
                <head>
                    <title>Resident Wise Summary Report</title>
                    <style>
                        @media print {
                            * {
                                -webkit-print-color-adjust: exact !important;
                                print-color-adjust: exact !important;
                            }
                            body {
                                font-family: Arial, sans-serif;
                                margin: 0;
                                padding: 10px;
                            }
                            .print-header {
                                text-align: center;
                                margin-bottom: 15px;
                            }
                            .print-title {
                                font-size: 18px;
                                font-weight: bold;
                                margin-bottom: 5px;
                            }
                            .print-date {
                                font-size: 12px;
                                margin-bottom: 10px;
                            }
                            .print-filters {
                                font-size: 12px;
                                margin-bottom: 15px;
                            }
                            .summary-section {
                                display: flex;
                                justify-content: space-between;
                                margin-bottom: 15px;
                                padding: 10px;
                                background-color: #f5f5f5;
                                border-radius: 5px;
                            }
                            .summary-block {
                                flex: 1;
                                padding: 0 10px;
                            }
                            .summary-title {
                                font-weight: bold;
                                margin-bottom: 5px;
                                font-size: 14px;
                            }
                            .summary-item {
                                display: flex;
                                justify-content: space-between;
                                margin-bottom: 3px;
                                font-size: 13px;
                            }
                            .summary-value {
                                font-weight: bold;
                            }
                            .divider {
                                border-left: 1px solid #ddd;
                                margin: 0 10px;
                            }
                            table {
                                width: 100%;
                                border-collapse: collapse;
                                font-size: 12px;
                            }
                            th, td {
                                border: 1px solid #ddd;
                                padding: 4px 6px;
                                text-align: left;
                            }
                            th {
                                background-color: #1976d2;
                                color: white;
                                font-weight: bold;
                            }
                            .status-badge {
                                display: inline-block;
                                padding: 2px 6px;
                                border-radius: 4px;
                                font-weight: 500;
                                font-size: 11px;
                                color: white;
                            }
                            @page {
                                size: auto;
                                margin: 5mm;
                            }
                        }
                    </style>
                </head>
                <body>
                    <div class="print-header">
                        ${logoHtml}
                        <div class="print-title">Resident Wise Summary Report</div>
                        <div class="print-date">Generated on: ${currentDate}</div>
                        <div class="print-filters">
                            ${selectedProperty ? `Property: ${selectedProperty.Name} | ` : ''}
                            ${selectedResident ? `Resident: ${selectedResident.Name} | ` : ''}
                            Date: ${fromDate.format('DD/MM/YYYY')} to ${toDate.format('DD/MM/YYYY')} |
                            Status: ${statusFilter}
                        </div>
                    </div>
                    
                    <!-- Summary Section -->
                    <div class="summary-section">
                        <div class="summary-block">
                            <div class="summary-title">Current Page Summary (${paginatedData.length} records)</div>
                            <div class="summary-item">
                                <span>Amount:</span>
                                <span class="summary-value">${currentPageSummary.totalAmount.toFixed(2)}</span>
                            </div>
                            <div class="summary-item">
                                <span>Received:</span>
                                <span class="summary-value" style="color: #4CAF50;">${currentPageSummary.paidAmount.toFixed(2)}</span>
                            </div>
                            <div class="summary-item">
                                <span>Balance:</span>
                                <span class="summary-value" style="color: #F44336;">${currentPageSummary.outstanding.toFixed(2)}</span>
                            </div>
                        </div>
                        
                        <div class="divider"></div>
                        
                        <div class="summary-block">
                            <div class="summary-title">Overall Summary (${filteredData.length} records)</div>
                            <div class="summary-item">
                                <span>Amount:</span>
                                <span class="summary-value">${overallSummary.totalAmount.toFixed(2)}</span>
                            </div>
                            <div class="summary-item">
                                <span>Received:</span>
                                <span class="summary-value" style="color: #4CAF50;">${overallSummary.paidAmount.toFixed(2)}</span>
                            </div>
                            <div class="summary-item">
                                <span>Balance:</span>
                                <span class="summary-value" style="color: #F44336;">${overallSummary.outstanding.toFixed(2)}</span>
                            </div>
                        </div>
                    </div>
                    
                    <table>
                        <thead>
                            <tr>
                                <th>BookNo</th>
                                <th>Resident</th>
                                <th>Amount</th>
                                <th>Received</th>
                                <th>Balance</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${paginatedData.map(row => `
                                <tr>
                                    <td>${row.Msg}</td>
                                    <td>${row.ResidentName}</td>
                                    <td>${row.Amount?.toFixed(2)}</td>
                                    <td>${row.RcdAmt?.toFixed(2)}</td>
                                    <td>${row.BalAmount?.toFixed(2)}</td>
                                    <td>
                                        <span class="status-badge" style="background-color: ${getStatus(row) === 'Paid' ? '#4caf50' : getStatus(row) === 'Overdue' ? '#f44336' : '#ff9800'}">
                                            ${getStatus(row)}
                                        </span>
                                    </td>
                                </tr>
                            `).join('')}
                        </tbody>
                    </table>
                </body>
            </html>
        `;

        printWindow.document.write(tableHtml);
        printWindow.document.close();
        printWindow.onload = function () {
            setTimeout(() => {
                printWindow.print();
                printWindow.close();
            }, 200);
        };
    };

    const exportToExcel = () => {
        if (filteredData.length === 0) {
            toast.warning("No data to export");
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Resident Wise Report');

        // ==================== Light Blue Border Definition ====================
        const lightBlueBorder = {
            top: { style: 'thin', color: { argb: 'FF81C4FF' } },
            left: { style: 'thin', color: { argb: 'FF81C4FF' } },
            bottom: { style: 'thin', color: { argb: 'FF81C4FF' } },
            right: { style: 'thin', color: { argb: 'FF81C4FF' } }
        };

        // ==================== TITLE ====================
        worksheet.mergeCells('A1:F1');
        const titleCell = worksheet.getCell('A1');
        titleCell.value = `Resident Wise Report | As on ${dayjs().format('DD-MMM-YYYY')}`;
        titleCell.font = { bold: true, size: 14, color: { argb: 'FFFFFFFF' } };
        titleCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '635BFF' } };
        titleCell.alignment = { horizontal: 'center', vertical: 'middle' };
        titleCell.border = lightBlueBorder;

        // ==================== HEADER ROW ====================
        const headers = [
            "BookNo", "Resident Name", "Amount", "Received", "Balance", "Status"
        ];

        const headerRow = worksheet.addRow(headers);

        headerRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '635BFF' } };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
            cell.border = lightBlueBorder;
        });

        headerRow.height = 22;

        // ==================== DATA ROWS ====================
        let totalAmount = 0;
        let totalReceived = 0;
        let totalBalance = 0;

        filteredData.forEach((item, index) => {
            const amount = Number(item.Amount || 0);
            const received = Number(item.RcdAmt || 0);
            const balance = Number(item.BalAmount || 0);

            totalAmount += amount;
            totalReceived += received;
            totalBalance += balance;

            const row = worksheet.addRow([
                item.Msg || '',
                item.ResidentName || '',
                amount,
                received,
                balance,
                getStatus(item)
            ]);

            // Alternate row coloring + Light Blue Border
            row.eachCell((cell) => {
                if (index % 2 === 0) {
                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF2F2F2' } };
                }
                cell.border = lightBlueBorder;
            });

            // Right align and format amount columns (C, D, E → columns 3,4,5)
            [3, 4, 5].forEach(col => {
                const cell = row.getCell(col);
                cell.numFmt = '#,##0.00';
                cell.alignment = { horizontal: 'right' };
            });

            // Status cell styling (Column F = 6)
            const statusCell = row.getCell(6);
            const status = getStatus(item);

            if (status === 'Paid') {
                statusCell.font = { bold: true, color: { argb: '006400' } };        // Dark Green
            } else if (status === 'Overdue') {
                statusCell.font = { bold: true, color: { argb: 'B71C1C' } };        // Dark Red
            } else {
                statusCell.font = { bold: true, color: { argb: 'E65100' } };        // Orange
            }
        });

        // ==================== TOTAL ROW ====================
        const totalRow = worksheet.addRow([
            'TOTAL', '', totalAmount, totalReceived, totalBalance, ''
        ]);

        totalRow.eachCell((cell, colNumber) => {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '635BFF' } };
            cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
            cell.border = lightBlueBorder;

            if (colNumber >= 3 && colNumber <= 5) {
                cell.numFmt = '#,##0.00';
                cell.alignment = { horizontal: 'right' };
            }
        });

        totalRow.height = 22;

        // ==================== PROFESSIONAL SUMMARY SECTION ====================
        const summaryStartRow = worksheet.lastRow.number + 2;

        const summaryData = [
            { label: "Total Amount", value: totalAmount },
            { label: "Total Received", value: totalReceived },
            { label: "Total Balance", value: totalBalance }
        ];

        summaryData.forEach((item, idx) => {
            const labelCell = worksheet.getCell(`D${summaryStartRow + idx}`);
            const valueCell = worksheet.getCell(`E${summaryStartRow + idx}`);

            labelCell.value = item.label;
            valueCell.value = item.value;

            labelCell.font = { bold: true };
            valueCell.font = { bold: true };

            valueCell.numFmt = '#,##0.00';
            valueCell.alignment = { horizontal: 'right' };

            // Light blue border for summary
            labelCell.border = lightBlueBorder;
            valueCell.border = lightBlueBorder;

            // Highlight Total Balance in red
            if (idx === 2) {
                valueCell.font = { bold: true, color: { argb: 'B71C1C' } };
            }
        });

        // ==================== COLUMN WIDTHS ====================
        worksheet.columns = [
            { width: 14 },  // A BookNo
            { width: 28 },  // B Resident Name
            { width: 16 },  // C Amount
            { width: 16 },  // D Received
            { width: 16 },  // E Balance
            { width: 14 }   // F Status
        ];

        // ==================== EXPORT ====================
        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const fileName = `ResidentWise_Report_${dayjs().format('DDMMYYYY')}.xlsx`;
            saveAs(blob, fileName);
        });
    };

    const handleBackClick = () => {
        navigate('/reports/accountsFinance')
    }

    const getCurrentPageSummary = (data, page, rowsPerPage) => {
        const startIndex = page * rowsPerPage;
        const endIndex = startIndex + rowsPerPage;
        const currentPageData = data.slice(startIndex, endIndex);

        return {
            totalAmount: currentPageData.reduce((sum, item) => sum + item.Amount, 0),
            paidAmount: currentPageData.reduce((sum, item) => sum + item.RcdAmt, 0),
            outstanding: currentPageData.reduce((sum, item) => sum + item.BalAmount, 0),
        };
    };

    const getOverallSummary = (data) => {
        return {
            totalAmount: data.reduce((sum, item) => sum + item.Amount, 0),
            paidAmount: data.reduce((sum, item) => sum + item.RcdAmt, 0),
            outstanding: data.reduce((sum, item) => sum + item.BalAmount, 0),
        };
    };
    useEffect(() => {
        if (filteredData.length > 0) {
            setSummary({
                currentPage: getCurrentPageSummary(filteredData, page, rowsPerPage),
                overall: getOverallSummary(filteredData)
            });
        } else {
            setSummary({
                currentPage: { totalAmount: 0, paidAmount: 0, outstanding: 0 },
                overall: { totalAmount: 0, paidAmount: 0, outstanding: 0 }
            });
        }
    }, [filteredData, page, rowsPerPage]);

    useEffect(() => {
        fetchData();
    }, [selectedProperty, paymentStatus]);

    const fetchData = async () => {
        setIsLoading(true);
        const apiFlag = paymentStatus === 'All' ? 'Dash' : paymentStatus;
        try {
            const currentDate = new Date();
            const formattedDate = currentDate.toISOString().split('T')[0];
            const response = await axiosInstance.post(`TrnBooking/GetSelectTrnPytAdv`, {
                PytAdvDt: formattedDate,
                Flag: apiFlag,
                PropId: selectedProperty.PropId || 0
            });

            if (response.data) {
                let formattedData = [];
                if (Array.isArray(response.data)) {
                    formattedData = response.data.map((advice) => ({
                        ...advice,
                        PytAdvDt: advice.PytAdvDt ? moment(advice.PytAdvDt).format('DD-MM-YYYY') : '',
                        DueDt: advice.DueDt ? moment(advice.DueDt).format('DD-MM-YYYY') : '',
                        DueDays: advice.DueDays ?? '0',
                        PytAdvFor: advice.PytAdvFor === 'D' ? 'Deposit' :
                            advice.PytAdvFor === 'R' ? 'Rent' :
                                advice.PytAdvFor === 'O' ? 'Other' :
                                    advice.PytAdvFor === 'T' ? 'TopUp' : '',
                    }));
                } else if (response.data.Status === 0 && Array.isArray(response.data.Data)) {
                    formattedData = response.data.Data.map((advice) => ({
                        ...advice,
                        PytAdvDt: advice.PytAdvDt ? moment(advice.PytAdvDt).format('DD-MM-YYYY') : '',
                        DueDt: advice.DueDt ? moment(advice.DueDt).format('DD-MM-YYYY') : '',
                        DueDays: advice.DueDays ?? '0',
                        // IsDepPaid: advice.IsDepPaid === 'Y' ? 'Paid' : (advice.IsDepPaid === 'N' || advice.IsDepPaid === '' || advice.IsDepPaid === null) ? 'UnPaid' : '',
                        PytAdvFor: advice.PytAdvFor === 'D' ? 'Deposit' :
                            advice.PytAdvFor === 'R' ? 'Rent' :
                                advice.PytAdvFor === 'O' ? 'Other' :
                                    advice.PytAdvFor === 'T' ? 'TopUp' : '',
                    }));
                }
                setData(formattedData);
                setFilteredRows(formattedData);
            } else {
                // toast.error(response.data?.Message || "Failed to load data");
            }
        } catch (error) {
            //   toast.error('Failed to connect to server');
        } finally {
            setIsLoading(false);
        }
    };

    const generatePaymentAdvice = async () => {
        if (selectedPendingRows.length === 0) {
            toast.warning("Please select at least one row");
            return;
        }
        setIsPendingLoading(true);
        try {
            const userId = parseInt(sessionStorage.getItem('UserId'));
            const selectedRowsData = filteredPendingData.filter(row =>
                selectedPendingRows.includes(row.BillCycle)
            );
            const formatDate = (dateString) => {
                const date = dateString ? new Date(dateString) : new Date();  // Use current date if missing
                return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} 00:00:00.000`;
            };

            const selectedAdviceData = selectedRowsData.map((row, index) => {
                return {
                    "DBFLAG": "I",
                    "PytAdvId": row.PytAdvId || 1,
                    "PytAdvNo": row.PytAdvNo || 1,
                    "PytAdvDt": formatDate(row.PytAdvDt),
                    "PytAdvFor": row.PytAdvFor || "R",
                    "BookId": row.BookId,
                    "ResidentId": row.ResidentId,
                    "PropId": row.PropId,
                    "Amount": row.Amount,
                    "BalAmount": row.BalAmount,
                    "Remark": "Generated from web",
                    "BookPytAdvNo": row.BookPytAdvNo || 1,
                    "RecId": index + 1, // Sequential IDs starting from 1
                    "RecdtlId": index + 1,
                    "OthChrgId": 1,
                    "RecDt": formatDate(row.RecDt),
                    "RcdAmt": row.RcdAmt || 0,
                    "DueAmt": row.DueAmt || 0,
                    "DueDt": formatDate(row.DueDt),
                    "Status": "1",
                    "CreatedBy": userId
                };
            });

            const payloadObj = {
                "TrnPytAdvList": selectedAdviceData
            };

            let payloadString = JSON.stringify(payloadObj);
            payloadString = payloadString.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
            payloadString = `"${payloadString}"`;
            const response = await axiosInstance.post(
                `TrnBooking/ManageTrnPytAdv`,
                payloadString, // Send as string
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );

            if (response.data && response.data.Status === 0) {
                toast.success("Payment advice generated successfully");
                setOpenModal(false);
                fetchData();
                fetchPendingAdviceData();
            } else {
                toast.error(response.data?.Message || "Failed to generate payment advice");
            }
        } catch (error) {
            if (error.response) {
                toast.error(error.response.data?.Message || "Failed to connect to server");
            } else {
                // toast.error("Failed to connect to server");
            }
        } finally {
            setIsPendingLoading(false);
        }
    };

    const handleRowDoubleClick = (PytAdvId) => {
        navigate('/adviceform', { state: { PytAdvId, mode: 'view' } });
    };

    const handleSelectPendingRow = (selectedRowsData) => {
        const selectedIds = selectedRowsData.map(row => row.BillCycle);
        setSelectedPendingRows(selectedIds);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const handleOpenPendingModal = () => {
        setOpenModal(true);
        fetchPendingAdviceData();
        setSelectedPendingRows([]);
    };

    const fetchPendingAdviceData = async () => {
        setIsPendingLoading(true);
        const currentDate = new Date();
        const formattedDate = currentDate.toISOString().split('T')[0];
        try {
            const response = await axiosInstance.post(`TrnBooking/GetSelectTrnPytAdv`, {
                "PytAdvDt": toDate.toISOString().split('T')[0],
                "Flag": '',
                PropId: selectedProperty.PropId
            });

            if (response.data && Array.isArray(response.data)) {
                setPendingData(response.data);
                setFilteredPendingData(response.data);
            } else if (response.data && response.data.Status === 0) {
                setPendingData(response.data.Data || []);
                setFilteredPendingData(response.data.Data || []);
            } else {
                // toast.error(response.data?.Message || "Failed to load pending advice data");
            }
        } catch (error) {
            // toast.error("Failed to connect to server");
        } finally {
            setIsPendingLoading(false);
        }
    };

    return (
        <Box sx={{
            width: '100%',
            height: '90vh',
            padding: '10px',
            backgroundColor: 'rgb(249, 249, 249)',
            position: 'relative'
        }}>
            <Box
                sx={{
                    backgroundColor: "#ffffff",
                    padding: { xs: "8px 16px", sm: "12px 16px" },
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
                    borderRadius: "12px",
                    margin: "10px auto",
                    maxWidth: "95%",
                    flexDirection: { xs: "column", sm: "column", md: "row" },
                    gap: 2,
                }}
            >
                <Breadcrumbs
                    aria-label="breadcrumb"
                    separator="›"
                    sx={{
                        fontSize: { xs: "14px", sm: "16px" },
                        display: "flex",
                        flexDirection: { xs: "column", sm: "column", md: "row" }
                    }}
                >
                    <Link
                        underline="hover"
                        color="#635bff"
                        sx={{ cursor: "pointer", fontWeight: "500", display: "flex", alignItems: "center" }}
                        onClick={() => navigate('/dashboard')}
                    >
                        <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                        <Box component="span">Home</Box>
                    </Link>
                    <Link
                        underline="hover"
                        color="#635bff"
                        sx={{ cursor: "pointer", fontWeight: "500" }}
                        onClick={() => navigate('/reports/accountsFinance')}
                    >
                        Report
                    </Link>

                    <Typography color="text.primary" sx={{ fontWeight: "500" }}>
                        Resident Wise Report
                    </Typography>
                </Breadcrumbs>

                <Box sx={{
                    display: "flex", alignItems: "center", gap: 1,
                    justifyContent: "flex-start"
                }}
                >
                    <Box>
                        <Tooltip title="Export to Excel" arrow>
                            <IconButton
                                onClick={exportToExcel}
                                disabled={filteredData.length === 0}
                                color="success"
                                sx={{
                                    backgroundColor: 'success.main',
                                    color: 'white',
                                    mr: 1,
                                    '&:hover': {
                                        backgroundColor: 'success.dark',
                                    }
                                }}
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" fill="currentColor" />
                                    <path d="M14 2V8H20" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M16 13H8" stroke="white" strokeWidth="2" strokeLinecap="round" />
                                    <path d="M16 17H8" stroke="white" strokeWidth="2" strokeLinecap="round" />
                                    <path d="M10 9H8" stroke="white" strokeWidth="2" strokeLinecap="round" />
                                </svg>
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="Print Report" arrow>
                            <IconButton
                                onClick={handlePrint}
                                disabled={filteredData.length === 0}
                                color="primary"
                                size='small'
                                sx={{
                                    backgroundColor: 'primary.main',
                                    color: 'white',
                                    mr: 1,
                                    '&:hover': {
                                        backgroundColor: 'primary.dark',
                                    }
                                }}
                            >
                                <PrintIcon />
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="Go to outstanding Report" arrow>
                            <IconButton
                                color="warning"
                                size='small'
                                onClick={() => navigate('/outstanding')}
                                sx={{
                                    backgroundColor: 'warning.main',
                                    color: 'white',
                                    '&:hover': {
                                        backgroundColor: 'warning.dark',
                                    }
                                }}
                            >
                                <ArrowForwardIcon />
                            </IconButton>
                        </Tooltip>
                    </Box>

                    <Tooltip title='Previous Page' arrow>
                        <IconButton
                            onClick={() => navigate('/reports/accountsFinance')}
                            sx={{
                                backgroundColor: '#635bff',
                                borderRadius: '50%',
                                width: 35,
                                height: 35,
                                '&:hover': {
                                    backgroundColor: '#635bff',
                                },
                                boxShadow: 3,
                            }}
                        >
                            <ArrowBackIcon sx={{ color: 'white' }} />
                        </IconButton>
                    </Tooltip>
                </Box>
            </Box>

            <Container maxWidth="xl" sx={{ py: 1 }}>
                <ToastContainer />
                {/* <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                    <Typography variant="h6" gutterBottom sx={{
                        fontWeight: 'bold',
                        color: 'primary.main',
                    }}>
                        <Tooltip title="Main Page" arrow>
                            <IconButton
                                onClick={handleBackClick}
                                sx={{
                                    left: '-5px',
                                    color: '#6a11cb',
                                    backgroundColor: 'rgba(106, 17, 203, 0.1)'
                                }}
                            >
                                <KeyboardBackspaceIcon />
                            </IconButton>
                        </Tooltip>
                        Resident Wise Report
                    </Typography>

                    <Box>
                        <Tooltip title="Export to Excel" arrow>
                            <IconButton
                                onClick={exportToExcel}
                                disabled={filteredData.length === 0}
                                color="success"
                                sx={{
                                    backgroundColor: 'success.main',
                                    color: 'white',
                                    mr: 1,
                                    '&:hover': {
                                        backgroundColor: 'success.dark',
                                    }
                                }}
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" fill="currentColor" />
                                    <path d="M14 2V8H20" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M16 13H8" stroke="white" strokeWidth="2" strokeLinecap="round" />
                                    <path d="M16 17H8" stroke="white" strokeWidth="2" strokeLinecap="round" />
                                    <path d="M10 9H8" stroke="white" strokeWidth="2" strokeLinecap="round" />
                                </svg>
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="Print Report" arrow>
                            <IconButton
                                onClick={handlePrint}
                                disabled={filteredData.length === 0}
                                color="primary"
                                size='small'
                                sx={{
                                    backgroundColor: 'primary.main',
                                    color: 'white',
                                    mr: 1,
                                    '&:hover': {
                                        backgroundColor: 'primary.dark',
                                    }
                                }}
                            >
                                <PrintIcon />
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="Go to outstanding Report" arrow>
                            <IconButton
                                color="warning"
                                size='small'
                                onClick={() => navigate('/outstanding')}
                                sx={{
                                    backgroundColor: 'warning.main',
                                    color: 'white',
                                    '&:hover': {
                                        backgroundColor: 'warning.dark',
                                    }
                                }}
                            >
                                <ArrowForwardIcon />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box> */}

                <FilterSection>
                    <Grid container spacing={3} alignItems="center">
                        <Grid item xs={12} md={2}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                                <DatePicker
                                    label="From Date"
                                    value={fromDate}
                                    onChange={(newValue) => setFromDate(newValue)}
                                    inputFormat="DD/MM/YYYY"

                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            fullWidth
                                            InputProps={{
                                                ...params.InputProps,
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <EventIcon color="action" />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    )}
                                />
                            </LocalizationProvider>
                        </Grid>

                        <Grid item xs={12} md={2}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                                <DatePicker
                                    label="To Date"
                                    value={toDate}
                                    onChange={(newValue) => setToDate(newValue)}
                                    inputFormat="DD/MM/YYYY"
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            fullWidth
                                            InputProps={{
                                                ...params.InputProps,
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <EventIcon color="action" />
                                                    </InputAdornment>
                                                ),
                                                sx: {
                                                    p: 0,
                                                    height: '42px',
                                                    '& input': {
                                                        padding: '8.5px 8px',
                                                    },
                                                },
                                            }}
                                            InputLabelProps={{
                                                sx: {
                                                    top: '-8px',
                                                },
                                            }}
                                        />
                                    )}
                                />
                            </LocalizationProvider>
                        </Grid>
                        {/* Property Autocomplete */}
                        <Grid item xs={12} md={3} >
                            <Autocomplete
                                options={property}
                                getOptionLabel={(option) => option?.Name || ''}
                                value={selectedProperty}
                                onChange={handlePropertyChange}
                                isOptionEqualToValue={(option, value) => option?.Id === value?.Id}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Select Property"
                                        variant="outlined"
                                        fullWidth

                                        InputProps={{
                                            ...params.InputProps,
                                            sx: {
                                                p: 0,
                                                height: '42px',
                                                '& input': {
                                                    padding: '8.5px 8px',
                                                },
                                            },
                                        }}

                                        sx={{
                                            m: 0, p: 0,
                                            '& .MuiOutlinedInput-root': {
                                                padding: 0,
                                            },
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <Autocomplete
                                options={residents}
                                getOptionLabel={(option) => option?.Name || ''}
                                value={selectedResident}
                                onChange={handleResidentChange}
                                isOptionEqualToValue={(option, value) => option?.Id === value?.Id}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Select Resident"
                                        variant="outlined"
                                        fullWidth
                                        InputProps={{
                                            ...params.InputProps,
                                            sx: {
                                                p: 0,
                                                height: '42px',
                                                '& input': {
                                                    padding: '8.5px 8px',
                                                },
                                            },
                                        }}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} md={2} sx={{ display: 'flex', gap: 2 }}>
                            <Tooltip title='click to see filtered data' arrow>
                                <StyledButton
                                    variant="contained"
                                    color="primary"
                                    onClick={fetchOutstandingReports}
                                    fullWidth
                                    disabled={tableLoading}
                                >
                                    {tableLoading ? <CircularProgress size={24} color="inherit" /> : 'Search'}
                                </StyledButton>
                            </Tooltip>
                            <Tooltip title='Clear all filters' arrow>
                                <StyledButton
                                    variant="outlined"
                                    color="primary"
                                    onClick={handleReset}
                                    fullWidth
                                    disabled={tableLoading}
                                >
                                    Reset
                                </StyledButton>
                            </Tooltip>
                        </Grid>
                    </Grid>
                </FilterSection>

                <Paper elevation={2} sx={{ p: 1, mb: 1, borderRadius: 2 }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                            <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', mb: 0 }}>
                                Current Page Summary ({paginatedData.length} records)
                            </Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={4}>
                                    <Typography variant="body2" color="text.secondary">Amount</Typography>
                                    <Typography variant="h6" color="primary">
                                        {summary.currentPage.totalAmount?.toFixed(2)}
                                    </Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography variant="body2" color="text.secondary">Received</Typography>
                                    <Typography variant="h6" color="success.main">
                                        {summary.currentPage.paidAmount?.toFixed(2)}
                                    </Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography variant="body2" color="text.secondary">Balance</Typography>
                                    <Typography variant="h6" color="error.main">
                                        {summary.currentPage.outstanding?.toFixed(2)}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={1} sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Divider orientation="vertical" flexItem />
                        </Grid>
                        <Grid item xs={12} md={5}>
                            <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', mb: 0 }}>
                                Overall Summary ({filteredData.length} records)
                            </Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={4}>
                                    <Typography variant="body2" color="text.secondary">Amount</Typography>
                                    <Typography variant="h6" color="primary">
                                        {summary.overall.totalAmount?.toFixed(2)}
                                    </Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography variant="body2" color="text.secondary">Received</Typography>
                                    <Typography variant="h6" color="success.main">
                                        {summary.overall.paidAmount?.toFixed(2)}
                                    </Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography variant="body2" color="text.secondary">Balance</Typography>
                                    <Typography variant="h6" color="error.main">
                                        {summary.overall.outstanding?.toFixed(2)}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>

                <StyledTableContainer component={Paper} ref={tableRef} >
                    <Table stickyHeader sx={{ minWidth: 650 }} size="small">
                        <StyledTableHead>
                            <TableRow sx={{ '& th': { py: 0.5 } }}>
                                <StyledTableCell sx={{ py: 0.5 }}>Property</StyledTableCell>
                                <StyledTableCell sx={{ py: 0.5 }}>BookNo</StyledTableCell>
                                <StyledTableCell sx={{ py: 0.5 }}>Resident</StyledTableCell>
                                <StyledTableCell sx={{ py: 0.5 }}>Mobile</StyledTableCell>
                                <StyledTableCell sx={{ py: 0.5 }}>Amount</StyledTableCell>
                                <StyledTableCell sx={{ py: 0.5 }}>Received</StyledTableCell>
                                <StyledTableCell sx={{ py: 0.5 }}>Balance</StyledTableCell>
                            </TableRow>
                        </StyledTableHead>
                        <TableBody>
                            {paginatedData?.length > 0 ? (
                                paginatedData.map((row) => (
                                    <TableRow
                                        key={row.PytAdvId}
                                        hover
                                        sx={{
                                            '&:last-child td, &:last-child th': { border: 0 },
                                            '& td': { py: 0.25 }
                                        }}
                                    >
                                        <TableCell sx={{ py: 0.25 }}>{row.PropName}</TableCell>
                                        <TableCell sx={{ py: 0.25 }}>{row.Msg}</TableCell>
                                        <TableCell sx={{ py: 0.25 }}>{row.ResidentName}</TableCell>
                                        <TableCell sx={{ py: 0.25 }}>{row.MobileNo}</TableCell>
                                        <TableCell sx={{ py: 0.25 }}>{row.Amount?.toFixed(2)}</TableCell>
                                        <TableCell sx={{ py: 0.25 }}>{row.RcdAmt?.toFixed(2)}</TableCell>
                                        <TableCell sx={{ py: 0.25 }}>{row.BalAmount?.toFixed(2)}</TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow sx={{ '& td': { py: 1 } }}>
                                    <TableCell colSpan={9} align="center">
                                        <Typography variant="body2" color="text.secondary">
                                            {tableLoading ? 'Loading data...' : 'No records found'}
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>

                    <Box
                        sx={{
                            position: 'sticky',
                            bottom: 0,
                            backgroundColor: 'background.paper',
                            borderTop: '1px solid',
                            borderColor: 'divider',
                            zIndex: 2,
                        }}
                    >
                        <TablePagination
                            rowsPerPageOptions={[50, 100, 500, 1000]}
                            component="div"
                            count={filteredData.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={(event) => {
                                setRowsPerPage(parseInt(event.target.value, 10));
                                setPage(0);
                            }}
                            sx={{
                                borderTop: '1px solid',
                                borderColor: 'divider',
                                '& .MuiTablePagination-toolbar': {
                                    flexWrap: 'wrap',
                                    justifyContent: 'space-between'
                                }
                            }}
                            labelDisplayedRows={({ from, to, count }) => (
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Typography variant="body2">
                                        Showing {from}-{to} of {count} records
                                    </Typography>
                                </Box>
                            )}
                            ActionsComponent={({ count, page, rowsPerPage, onPageChange }) => (
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Typography variant="body2" sx={{ mr: 2 }}>
                                        Page Totals:
                                    </Typography>
                                    <Chip
                                        label={`Total: ${summary.currentPage.totalAmount?.toFixed(2)}`}
                                        size="small"
                                        sx={{ mr: 1, backgroundColor: 'primary.light', color: 'primary.contrastText' }}
                                    />
                                    <Chip
                                        label={`Paid: ${summary.currentPage.paidAmount?.toFixed(2)}`}
                                        size="small"
                                        sx={{ mr: 1, backgroundColor: 'success.light', color: 'success.contrastText' }}
                                    />
                                    <Chip
                                        label={`Due: ${summary.currentPage.outstanding?.toFixed(2)}`}
                                        size="small"
                                        sx={{ mr: 2, backgroundColor: 'error.light', color: 'error.contrastText' }}
                                    />
                                    <IconButton
                                        onClick={() => onPageChange(null, page - 1)}
                                        disabled={page === 0}
                                        aria-label="previous page"
                                        size="small"
                                    >
                                        <KeyboardArrowLeft />
                                    </IconButton>

                                    <Typography variant="body2" sx={{ mx: 1 }}>
                                        {page + 1} of {Math.ceil(count / rowsPerPage)}
                                    </Typography>

                                    <IconButton
                                        onClick={() => onPageChange(null, page + 1)}
                                        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                                        aria-label="next page"
                                        size="small"
                                    >
                                        <KeyboardArrowRight />
                                    </IconButton>
                                </Box>
                            )}
                        />
                    </Box>
                </StyledTableContainer>

                <Dialog
                    open={openModal}
                    onClose={handleCloseModal}
                    maxWidth="lg"
                    fullWidth
                    PaperProps={{
                        sx: {
                            maxHeight: '90vh',
                            minHeight: '50vh'
                        }
                    }}
                >
                    <DialogTitle sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        background: '#dddbff',
                        padding: '16px 24px'
                    }}>
                        <Typography variant="h6" component="div">
                            Pending Payment Advice Details
                        </Typography>
                        <Grid>
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<SendIcon />}
                                onClick={generatePaymentAdvice}
                                disabled={selectedPendingRows.length === 0 || isPendingLoading}
                                sx={{
                                    backgroundColor: '#635bff',
                                    mr: 1,
                                    '&:hover': {
                                        backgroundColor: '#4b44c9',
                                    }
                                }}
                            >
                                Generate Advice
                            </Button>

                            <Button
                                onClick={handleCloseModal}
                                variant="outlined"
                                sx={{ borderColor: '#635bff', color: '#635bff' }}
                            >
                                Close
                            </Button>
                        </Grid>
                    </DialogTitle>
                    <DialogContent dividers>
                        {isPendingLoading ? (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
                                <CircularProgress />
                            </Box>
                        ) : pendingData.length === 0 ? (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
                                <Typography variant="h6" color="error">
                                    No Pending Record Found
                                </Typography>
                            </Box>
                        ) : (
                            <TableComponentPending
                                columns={pendingColumns}
                                rows={pendingData}
                                filteredRows={filteredPendingData}
                                handleSearchChange={handlePendingSearchChange}
                                handleRowDoubleClick={handleRowDoubleClick}
                                title="Payment"
                                titleMaster="Pending Advice"
                                isLoading={isPendingLoading}
                                onSelectRow={handleSelectPendingRow}
                                selectedRows={selectedPendingRows}
                                setSelectedRows={setSelectedPendingRows}
                            />
                        )}
                    </DialogContent>
                </Dialog>
            </Container>
        </Box>
    );
};

export default ResidentWiseDtl;
